import React from 'react';
import { CommentEventMapping, CommentEventType } from '@ygtechnologies/bygr-frontend-chat';
import { CommentListEventBuyerAcceptedInvitation } from './CommentListEventBuyerAcceptedInvitation';
import { CommentListEventBuyerRemoved } from './CommentListEventBuyerRemoved';
import { CommentListEventItemChangeRequest } from './CommentListEventItemChangeRequest';
import { CommentListEventItemOffer } from './CommentListEventItemOffer';
import { CommentListEventChangeRequestEdited } from './CommentListEventChangeRequestEdited';

export const commentEventMapping: CommentEventMapping = {
    [CommentEventType.BuyerAcceptedInvitation]: (comment, extraProps) => (
        <CommentListEventBuyerAcceptedInvitation comment={comment} />
    ),
    [CommentEventType.AdditionalBuyerAcceptedInvitation]: (comment, extraProps) => (
        <CommentListEventBuyerAcceptedInvitation comment={comment} isAdditional />
    ),
    [CommentEventType.BuyerRemoved]: (comment, extraProps) => <CommentListEventBuyerRemoved comment={comment} />,
    [CommentEventType.LastBuyerRemoved]: (comment, extraProps) => (
        <CommentListEventBuyerRemoved comment={comment} isLastBuyer />
    ),
    [CommentEventType.ChangeRequestEvent]: (comment, extraProps) => <CommentListEventItemChangeRequest comment={comment} />,
    [CommentEventType.ChangeRequestEdited]: (comment, extraProps) => (
        <CommentListEventChangeRequestEdited comment={comment} />
    ),
    [CommentEventType.OfferEvent]: (comment, extraProps) => <CommentListEventItemOffer comment={comment} />,
};
